import React from 'react';

export default function Home() {
  return (
    <main className="home">
      <h2>Welcome to our page</h2>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe temporibus
        repellendus magni voluptatibus iure unde animi, velit mollitia necessitatibus
        cupiditate inventore. Sed deleniti fugiat cum quibusdam. Ea enim incidunt officiis
        inventore. A vero quos ducimus eligendi tenetur, perferendis blanditiis iste nulla&nbsp;
        dolorum dicta deserunt placeat labore saepe non ratione adipisci ea corporis&nbsp;
        delectus veritatis. Consequuntur tempora voluptatem, et, velit delectus soluta&nbsp;
        at dolor, iusto inventore nobis magnam&nbsp;
        blanditiis architecto aliquid doloremque. Repudiandae ad nam quos assumenda&nbsp;
        vel, maxime praesentium&nbsp;sed. Recusandae aliquam expedita dicta amet beatae&nbsp;
        temporibus omnis necessitatibus? Culpa ipsum&nbsp;
        quidem a autem error ea eius distinctio ab beatae!
      </p>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Saepe temporibus
        repellendus magni voluptatibus iure unde animi, velit mollitia necessitatibus
        cupiditate inventore. Sed deleniti fugiat cum quibusdam. Ea enim incidunt officiis
        inventore. A vero quos ducimus eligendi tenetur, perferendis blanditiis iste nulla&nbsp;
        dolorum dicta deserunt placeat labore saepe non ratione adipisci ea corporis&nbsp;
        delectus veritatis. Consequuntur tempora voluptatem, et, velit delectus soluta&nbsp;
        at dolor, iusto inventore nobis magnam&nbsp;
        blanditiis architecto aliquid doloremque. Repudiandae ad nam quos assumenda&nbsp;
        vel, maxime praesentium&nbsp;sed. Recusandae aliquam expedita dicta amet beatae&nbsp;
        temporibus omnis necessitatibus? Culpa ipsum&nbsp;
        quidem a autem error ea eius distinctio ab beatae!
      </p>
    </main>
  );
}
